import { render, staticRenderFns } from "./prospeccaoLista.vue?vue&type=template&id=822d7bf8&scoped=true"
import script from "./prospeccaoLista.vue?vue&type=script&lang=js"
export * from "./prospeccaoLista.vue?vue&type=script&lang=js"
import style0 from "./prospeccaoLista.vue?vue&type=style&index=0&id=822d7bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822d7bf8",
  null
  
)

export default component.exports